import { useModal } from '@/contexts/modal'
import AddIcons from '@/icons/AddIcons'
import { IPermissionProps } from '@/types/shared'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface ICloneProps extends IPermissionProps {
    contract: CustomerContract
    contractID: number
}
const RetentionComponent: React.FC<ICloneProps> = ({
    contract,
    contractID = 0,
}) => {
    const { t } = useTranslation()

    const { open, setModal } = useModal()

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                startIcon={<AddIcons />}
                onClick={() =>
                    setModal('ContractModals/CreateSubcontractModal/index', {
                        contract,
                        contractID: contractID,
                    })
                }
                disabled={open}
            >
                {t('subcontract-create')}
            </Button>
            {/* {create && <Dialog open={true}></Dialog>} */}
        </>
    )
}

import { CustomerContract } from '@/modules/Contract/types'

const CreateSubcontract = (props: ICloneProps) => {
    return <RetentionComponent {...props} />
}
export default CreateSubcontract
